var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGeoLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.426,46h-.774c-2.784-1.208-5.228-3.184-7.394-5.285C7.974,32.674,1.371,19.822,9.434,9.218,16.935-.647,32.002-.372,39.023,9.871c6.778,9.887,1.751,20.875-5.355,28.824-2.579,2.885-5.709,5.672-9.242,7.305ZM23.206,11.385c-5.659.505-9.224,6.458-7.047,11.723,2.669,6.455,11.709,7.051,15.189.975,3.428-5.986-1.318-13.306-8.142-12.697Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.376,14.65c4.306-.491,7.317,4.159,5.074,7.91-2.307,3.859-8.218,3.074-9.46-1.25-.883-3.072,1.2-6.297,4.387-6.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeoLocation);
export default __webpack_public_path__ + "static/media/icon-geo-location.96ae96a2ec0f2865147229273c969ad3.svg";
export { ForwardRef as ReactComponent };